export default function useAuthToken() {
  const storedToken = localStorage.getItem('okta-token-storage');
  const accessToken = storedToken ? JSON.parse(storedToken || '{}')
    .accessToken?.accessToken : '';
  return accessToken;
}

// Non-hook getter: reads the current token from localStorage at call time.
// Use this inside react-query queryFns so invalidateQueries()/refetch picks up
// a freshly-renewed token instead of the value captured in the render closure.
export function getAuthToken(): string {
  const storedToken = localStorage.getItem('okta-token-storage');
  const accessToken = storedToken ? JSON.parse(storedToken || '{}')
    .accessToken?.accessToken : '';
  return accessToken || '';
}
